'use client'
import React, { PropsWithChildren } from 'react'
import styles from './styles.module.scss'

const ParagraphTitle: React.FC<PropsWithChildren> = ({ children }) => {
  return <div className={styles.paragraphTitle}>{children}</div>
}

export default ParagraphTitle
